import { AxiosInstance } from "axios";
import ProductInterface from "@/types/app/products";

export async function getProducts(url: string, api: AxiosInstance) {
  const response = await api.get(url);
  const products = response.data as ProductInterface[];
  return products;
}
